import React, { useState } from 'react';
import { compressImage } from '../../utils/imageCompress';

export default function CompetitorLogoUpload({ competitorId, currentLogo, onLogoUpdated }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentLogo || null);
  const [error, setError] = useState(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError(null);
    setUploading(true);

    try {
      const compressedData = await compressImage(file);
      setPreview(compressedData);

      if (competitorId) {
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/crm/competitors/${competitorId}/upload-logo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({ imageData: compressedData }),
        });

        if (!response.ok) {
          throw new Error((await response.json()).error || 'Upload failed');
        }

        const result = await response.json();
        setPreview(result.logo_url);
        if (onLogoUpdated) onLogoUpdated(result.logo_url);
      }
    } catch (err) {
      setError(err.message);
      setPreview(currentLogo);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'center' }}>
      {preview ? (
        <img
          src={preview}
          alt="Company logo"
          style={{
            maxWidth: 80,
            maxHeight: 80,
            objectFit: 'contain',
            background: '#1E2D45',
            padding: 6,
            borderRadius: 4,
            border: '1px solid #1E2D45',
          }}
        />
      ) : (
        <div style={{
          width: 80,
          height: 80,
          background: '#1E2D45',
          border: '1px dashed #1E2D45',
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6B7280',
          fontSize: 11,
        }}>
          No logo
        </div>
      )}

      <label style={{
        padding: '5px 10px',
        background: '#22D3EE44',
        color: '#22D3EE',
        border: '1px solid #22D3EE66',
        borderRadius: 3,
        cursor: uploading ? 'not-allowed' : 'pointer',
        fontSize: 10,
        fontWeight: 500,
        opacity: uploading ? 0.6 : 1,
        whiteSpace: 'nowrap',
      }}>
        {uploading ? 'Uploading...' : 'Upload Logo'}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          disabled={uploading}
          style={{ display: 'none' }}
        />
      </label>

      {error && <div style={{ color: '#EF4444', fontSize: 10 }}>{error}</div>}
    </div>
  );
}
